module.exports = __webpack_public_path__ + "static/media/vipcard.485ee6fc.jpg";